import React from "react";
import { renderRoutes } from "./generateRoutes";
import { Navigate } from "react-router-dom";

import DashboardLayout from "../components/DashboardLayout";
import LoginLayout from "../components/LoginLayout";
import HomePageLayout from "../components/HomepageLayout";

// Lazy load views
const Login = React.lazy(() => import("../Views/Admin/Login"));
const Home = React.lazy(() => import("../Views/Home"));
const PricingPlan = React.lazy(() => import("../Views/PackagePlan")); // Uncomment if needed
const Solutions = React.lazy(() => import("../Views/Solutions/Index"));
const SolutionDetail = React.lazy(() => import("../Views/Solutions/Detail"));
const UserProfile = React.lazy(() => import("../Views/Admin/UserProfile"));
const Projects = React.lazy(() => import("../Views/Projects"));
const ProjectsMain = React.lazy(() => import("../Views/Admin/Projects/Main"));
const View = React.lazy(() => import("../Views/Admin/Projects/View"));
const Credits = React.lazy(() => import("../Views/Admin/Credits"));
const Users = React.lazy(() => import("../Views/Admin/Users"));
const ContactUs = React.lazy(() => import("../Views/Contactus"));
const NotFound = React.lazy(() => import("../Views/NorFound"));
const Return = React.lazy(() =>
  import("../components/Payments").then((module) => ({
    default: module.Return,
  })),
);

export const routes = [
  {
    layout: HomePageLayout,
    routes: [
      {
        name: "home",
        title: "Home page",
        component: Home,
        path: "/",
        isPublic: true,
      },
      {
        name: "projects",
        title: "Project page",
        component: Projects,
        path: "/projects/:slug",
        isPublic: true,
      },
      {
        name: "pricing",
        title: "Pricing page",
        component: PricingPlan,
        path: "/pricing",
        isPublic: true,
      },
      {
        name: "solutions",
        title: "Solutions page",
        component: Solutions,
        path: "/solutions",
        isPublic: true,
      },
      {
        name: "solution-detail",
        title: "Solution detail page",
        component: SolutionDetail,
        path: "/solutions/:slug",
        isPublic: true,
      },
      {
        name: "contact-us",
        title: "Contact page",
        component: ContactUs,
        path: "/contact-us",
        isPublic: true,
      },
    ],
  },
  {
    layout: LoginLayout,
    routes: [
      {
        name: "login",
        title: "Login page",
        component: Login,
        path: "/login",
        isPublic: true,
      },
    ],
  },
  {
    layout: DashboardLayout,
    routes: [
      {
        name: "admin",
        title: "Admin",
        hasSiderLink: true,
        isPublic: false,
        routes: [
          {
            name: "admin",
            title: "Admin",
            hasSiderLink: true,
            component: () => <Navigate to={"/admin/profile"} />,
            path: "/admin",
            isPublic: false,
          },
          {
            name: "profile",
            title: "Profile",
            hasSiderLink: true,
            component: UserProfile,
            path: "/admin/profile",
            isPublic: false,
          },
          {
            name: "users",
            title: "Users",
            hasSiderLink: true,
            component: Users,
            path: "/admin/users",
            isPublic: false,
          },
          {
            name: "credits",
            title: "Credits",
            hasSiderLink: true,
            component: Credits,
            path: "/admin/credits",
            isPublic: false,
          },
          {
            name: "return",
            title: "Return",
            hasSiderLink: true,
            component: Return,
            path: "/admin/return",
            isPublic: false,
          },
          {
            name: "projects",
            title: "Projects",
            hasSiderLink: true,
            routes: [
              {
                name: "projects-list",
                title: "Projects List",
                hasSiderLink: true,
                component: ProjectsMain,
                path: "/admin/projects",
              },
              {
                name: "view-projects",
                title: "View Project",
                hasSiderLink: true,
                component: View,
                path: "/admin/project/:id",
              },
              {
                name: "project-report",
                title: "Project Report",
                hasSiderLink: true,
                component: Projects,
                path: "/admin/project/:slug/reports",
              },
            ],
          },
        ],
      },
    ],
  },
  {
    layout: LoginLayout,
    routes: [
      {
        name: "notFound",
        title: "Not Found",
        component: NotFound,
        path: "*",
        isPublic: true,
      },
    ],
  },
];

export const Routes = renderRoutes(routes);
